// Anita Week 9 / Day 2 — Why Do I Create? Purpose and Audience.
// Verbatim from FINAL Week 9 Part A (Creator) source-of-truth package.
// Staged on disk; Week 9 remains a locked placeholder until Days 4–5 are authored.

const day2 = {
  id: 'day-2',
  studentId: 'anita',
  weekId: 'week-9',
  dayId: 'day-2',
  status: 'active',
  title: 'Зачем я создаю? Цель и аудитория / Why Do I Create? Purpose and Audience',
  shortTitle: 'Цель и аудитория / Purpose and Audience',
  theme: 'Анита учится понимать, что полезный контент начинается с цели и безопасной аудитории. / Anita learns that useful content begins with a purpose and a safe audience.',
  estimatedTimeLabel: '60–90 минут / 60–90 minutes',
  lessonTiming: { minMinutes: 60, maxMinutes: 90, breaks: 2 },
  bilingualMode: 'ru-primary-en-helper',
  readingLevel: 'grade-2',
  courseLayers: ['reading', 'math', 'creator-mindset', 'purpose', 'audience', 'benefit', 'spelling', 'creative', 'speech'],
  nimnyIntro:
    'Нимни достала карточку «Зачем?». Автор не просто делает красивую картинку. Автор думает: кому это поможет, что объяснит и почему это полезно. Сегодня Анита выберет цель и безопасную аудиторию для маленького полезного контента. / Nimny takes out a "Why?" card. A creator does not only make a pretty picture. A creator thinks: who will this help, what will it explain, and why is it useful. Today Anita chooses a purpose and a safe audience for a small helpful content piece.',
  goals: [
    'Понять слова цель, аудитория, польза, объяснить. / Understand purpose, audience, benefit, explain.',
    'Отличать «просто красиво» от «полезно и понятно». / Tell "just pretty" from "useful and clear".',
    'Выбрать безопасную аудиторию: семья, родитель, младший ребёнок, Нимни. / Choose a safe audience: family, parent, younger child, Nimny.',
    'Решать задачи на идеи, benefit cards и шаги проекта. / Solve idea, benefit card and project step tasks.',
    'Сделать Useful Content Card. / Make a Useful Content Card.',
    'Объяснить цель родителю. / Explain purpose to parent.'
  ],
  vocabulary: [
    { term: 'цель / purpose', definition: 'зачем я это делаю. / why I do this.' },
    { term: 'аудитория / audience', definition: 'для кого я это делаю. / for whom I do this.' },
    { term: 'польза / benefit', definition: 'чем это помогает. / how it helps.' },
    { term: 'объяснить / explain', definition: 'сделать понятным. / make it clear.' },
    { term: 'пример / example', definition: 'маленькая история или случай. / a small story or case.' },
    { term: 'шаг / step', definition: 'часть плана. / a part of the plan.' },
    { term: 'карточка / card', definition: 'маленький лист с идеей. / a small sheet with an idea.' },
    { term: 'понятно / clear', definition: 'легко понять. / easy to understand.' },
    { term: 'безопасно / safe', definition: 'не просит личные данные и не публикуется онлайн. / does not ask for personal data and is not posted online.' },
    { term: 'черновик / draft', definition: 'первая версия работы. / the first version of the work.' }
  ],
  onlineTasks: [
    { id: 'reading-words', type: 'text', title: 'Задание 1 — Слова цели / Purpose Words',
      prompt: 'Прочитай по-русски:\n\nцель\nаудитория\nпольза\nобъяснить\nпример\nшаг\nкарточка\nпонятно\nбезопасно\nчерновик',
      ruPrimaryText: 'Прочитай 10 русских слов цели.',
      enHelpText: 'Read the Russian purpose words first. English is only for help.',
      answer: 'Attempted Russian reading.' },
    { id: 'reading-sentences', type: 'text', title: 'Задание 2 — Маленькое чтение / Short Reading',
      prompt: 'Прочитай по-русски:\n\nЦель отвечает на вопрос: зачем?\nАудитория отвечает на вопрос: для кого?\nПолезный контент помогает понять или сделать.\nМой черновик не должен быть идеальным.',
      ruPrimaryText: 'Прочитай 4 короткие фразы цели и аудитории.',
      enHelpText: 'Purpose answers: why? Audience answers: for whom? Useful content helps someone understand or do something. My draft does not have to be perfect.',
      answer: 'Attempted Russian reading.' },
    { id: 'purpose-audience-match', type: 'text', title: 'Задание 3 — Цель и аудитория / Purpose and Audience',
      prompt: 'Соедини идею с безопасной аудиторией.\n\n1. Карточка «как попросить помощи».\n2. Мини-гайд «как читать карту».\n3. Постер «не вводи пароль».\n4. Схема «как измерить предмет».\n5. Рисунок «стоп — уйти — рассказать».\n\nA. младший ребёнок, которому трудно с картой\nB. Нимни, которая учится измерять\nC. семья, которая повторяет безопасность\nD. родитель и ребёнок дома\nE. ребёнок, который забывает правило пароля',
      ruPrimaryText: 'Соедини 5 идей с безопасной аудиторией A–E.',
      enHelpText: 'Match 5 ideas with safe audiences A–E.',
      answer: '1-D; 2-A; 3-E; 4-B; 5-C.' },
    { id: 'useful-not-useful-sort', type: 'classify', title: 'Задание 4 — Полезно или просто красиво? / Useful or Just Pretty?',
      prompt: 'Разложи 12 карточек.\n\nКатегории:\n1. Полезно и понятно.\n2. Просто красиво, но мало пользы.\n3. Нужна проверка родителя.\n\nКарточки:\n1. Постер «пей воду» без объяснения, когда и зачем.\n2. Карточка «если потерялась — остановись и попроси помощь».\n3. Рисунок Нимни с красивыми звёздами без текста.\n4. Мини-гайд «3 шага: стоп, уйти, рассказать».\n5. Список настоящих телефонов семьи.\n6. Схема «как измерить линейкой».\n7. Обещание «это всегда решит любую проблему».\n8. Карточка «спроси родителя перед поиском».\n9. Картинка без заголовка и без смысла.\n10. Мини-план «идея → черновик → проверка».\n11. Фото ребёнка и название школы.\n12. Постер «не вводи пароль».',
      ruPrimaryText: 'Разложи 12 карточек: полезно / просто красиво / нужна проверка родителя.',
      enHelpText: 'Sort 12 cards: useful and clear / just pretty / needs parent check.',
      categories: [
        { id: 'useful', label: 'Полезно и понятно / Useful and clear' },
        { id: 'pretty', label: 'Просто красиво, но мало пользы / Just pretty' },
        { id: 'parent', label: 'Нужна проверка родителя / Needs parent check' }
      ],
      items: [
        { id: 'm1', label: '1. Постер «пей воду» без объяснения.', category: 'pretty' },
        { id: 'm2', label: '2. Карточка «если потерялась — остановись и попроси помощь».', category: 'useful' },
        { id: 'm3', label: '3. Рисунок Нимни с красивыми звёздами без текста.', category: 'pretty' },
        { id: 'm4', label: '4. Мини-гайд «3 шага: стоп, уйти, рассказать».', category: 'useful' },
        { id: 'm5', label: '5. Список настоящих телефонов семьи.', category: 'parent' },
        { id: 'm6', label: '6. Схема «как измерить линейкой».', category: 'useful' },
        { id: 'm7', label: '7. Обещание «это всегда решит любую проблему».', category: 'parent' },
        { id: 'm8', label: '8. Карточка «спроси родителя перед поиском».', category: 'useful' },
        { id: 'm9', label: '9. Картинка без заголовка и без смысла.', category: 'pretty' },
        { id: 'm10', label: '10. Мини-план «идея → черновик → проверка».', category: 'useful' },
        { id: 'm11', label: '11. Фото ребёнка и название школы.', category: 'parent' },
        { id: 'm12', label: '12. Постер «не вводи пароль».', category: 'useful' }
      ],
      answer: 'Полезно: 2,4,6,8,10,12. Просто красиво: 1,3,9. Нужна проверка: 5,7,11 (5 и 11 содержат личные данные; 7 — слишком большое обещание).' },
    { id: 'math-benefit-cards', type: 'text', title: 'Задание 5 — Карточки пользы / Benefit Cards',
      prompt: 'У Нимни есть 4 идеи.\nДля каждой идеи она пишет 3 карточки пользы.\n\nОтветь:\n1. Сколько карточек пользы всего?\n2. Если 2 идеи она оставит на потом, сколько идей останется?\n3. Для оставшихся 2 идей она пишет по 5 шагов. Сколько шагов?\n4. Сколько всего карточек и шагов: 12 benefit cards + 10 steps?',
      ruPrimaryText: 'Реши 4 задачи про benefit cards и шаги.',
      enHelpText: 'Solve 4 benefit-card and step problems.',
      answer: '1) 4 × 3 = 12. 2) 4 − 2 = 2. 3) 2 × 5 = 10. 4) 12 + 10 = 22.' },
    { id: 'math-audience-table', type: 'text', title: 'Задание 6 — Таблица аудитории / Audience Table',
      prompt: 'Прочитай таблицу:\n\nСемья — 6 карточек\nМладшие дети — 8 карточек\nРодитель — 5 карточек\nНимни — 7 карточек\n\nОтветь:\n1. У какой аудитории больше всего карточек?\n2. На сколько 8 больше, чем 5?\n3. Сколько карточек у семьи и Нимни вместе?\n4. Если 24 карточки разделить поровну на 6 групп, сколько в каждой группе?',
      ruPrimaryText: 'Реши 4 задачи по таблице аудитории.',
      enHelpText: 'Solve 4 audience-table problems.',
      answer: '1) Младшие дети. 2) 8 − 5 = 3. 3) 6 + 7 = 13. 4) 24 ÷ 6 = 4.' },
    { id: 'mini-purpose-graph', type: 'text', title: 'Задание 7 — Мини-график целей / Mini Purpose Graph',
      prompt: 'Нимни записала цели проектов:\n\nобъяснить — 5\nпредупредить — 3\nпомочь выбрать — 4\nнапомнить — 2\n\nНарисуй квадратики:\n\nобъяснить: □ □ □ □ □\nпредупредить: □ □ □\nпомочь выбрать: □ □ □ □\nнапомнить: □ □\n\nОтветь:\n1. Какая цель чаще всего?\n2. На сколько «объяснить» больше, чем «напомнить»?\n3. Сколько всего целей в таблице?',
      ruPrimaryText: 'Нарисуй мини-график целей и реши 3 задачи.',
      enHelpText: 'Draw the mini purpose graph and answer 3 questions.',
      answer: '1) Объяснить. 2) 5 − 2 = 3. 3) 5 + 3 + 4 + 2 = 14.' },
    { id: 'spelling-purpose', type: 'text', title: 'Задание 8 — Правописание / Spelling',
      prompt: 'Напиши:\n\nцель\nпольза\nпример\nшаг\nчерновик\n\nВставь буквы:\n\nц_ль\nп_льза\nприм_р\nш_г\nчерн_вик',
      ruPrimaryText: 'Напиши 5 слов и вставь пропущенные буквы.',
      enHelpText: 'Write 5 words and fill in the missing letters.',
      answer: 'цель, польза, пример, шаг, черновик.' },
    { id: 'creative-useful-content-card', type: 'text', title: 'Задание 9 — Useful Content Card / Карточка полезного контента',
      prompt: 'Сделай карточку полезного контента.\n\nЗаполни:\n\nМоя тема: ______.\nМоя цель: ______.\nКому поможет: ______.\nЧто объяснит: ______.\nПочему полезно: ______.\n\nНарисуй маленький значок темы.',
      ruPrimaryText: 'Сделай Useful Content Card: тема, цель, аудитория, объяснение, польза, значок.',
      enHelpText: 'Make a Useful Content Card with topic, purpose, audience, explanation, benefit and icon.',
      answer: 'Open-ended. Accept if Anita fills purpose, audience, explanation and benefit.' },
    { id: 'speech-purpose-explain', type: 'text', title: 'Задание 10 — Объясни родителю / Explain to Parent',
      prompt: 'Скажи родителю по-русски:\n\nМоя цель — ______.\nМоя аудитория — ______.\nМой контент поможет понять ______.',
      ruPrimaryText: 'Скажи родителю цель, аудиторию и пользу по-русски.',
      enHelpText: 'Tell parent the purpose, audience and benefit in Russian.',
      answer: 'Accept if Anita explains purpose, audience and benefit in Russian with support.' }
  ],
  notebookInstructions: [
    'Если нет принтера:',
    '1. Напиши слова дня.',
    '2. Прочитай 4 фразы.',
    '3. Соедини 5 идей с безопасной аудиторией.',
    '4. Разложи 8 карточек полезно/красиво/проверить с родителем.',
    '5. Реши задачи про benefit cards и audience table.',
    '6. Нарисуй мини-график целей.',
    '7. Сделай Useful Content Card.',
    '8. Объясни цель родителю.'
  ],
  printWorksheet: {
    title: 'Зачем я создаю? Цель и аудитория / Why Do I Create? Purpose and Audience',
    subtitle: 'Неделя 9 · День 2 / Week 9 · Day 2',
    pages: [
      { title: 'Маршрут дня / Route',
        blocks: [
          { type: 'text', text: 'Имя: __________________________   Дата: __________________________' },
          { type: 'text', text: 'Миссия: Нимни спрашивает: «Зачем ты создаёшь?» Сегодня ты выберешь цель, безопасную аудиторию и пользу своего маленького контента.' },
          { type: 'text', text: 'Задание 1 — Слова цели. Прочитай и обведи:' },
          { type: 'list', items: [
            'цель / purpose',
            'аудитория / audience',
            'польза / benefit',
            'объяснить / explain',
            'пример / example',
            'шаг / step',
            'карточка / card',
            'понятно / clear',
            'безопасно / safe',
            'черновик / draft'
          ] },
          { type: 'text', text: 'Задание 2 — Маленькое чтение. Поставь галочку:' },
          { type: 'list', items: [
            '□ Цель отвечает на вопрос: зачем?',
            '□ Аудитория отвечает на вопрос: для кого?',
            '□ Полезный контент помогает понять или сделать.',
            '□ Мой черновик не должен быть идеальным.'
          ] }
        ] },
      { title: 'Цель, аудитория и математика / Purpose, Audience and Math',
        blocks: [
          { type: 'text', text: 'Задание 3 — Цель и аудитория. Соедини:' },
          { type: 'list', items: [
            '1. Карточка «как попросить помощи». → ____',
            '2. Мини-гайд «как читать карту». → ____',
            '3. Постер «не вводи пароль». → ____',
            '4. Схема «как измерить предмет». → ____',
            '5. Рисунок «стоп — уйти — рассказать». → ____'
          ] },
          { type: 'list', items: [
            'A. младший ребёнок, которому трудно с картой',
            'B. Нимни, которая учится измерять',
            'C. семья, которая повторяет безопасность',
            'D. родитель и ребёнок дома',
            'E. ребёнок, который забывает правило пароля'
          ] },
          { type: 'text', text: 'Задание 4 — Полезно или просто красиво? Напиши P, K или R: P = полезно и понятно, K = красиво, но мало пользы, R = нужна проверка родителя.' },
          { type: 'list', items: [
            '1. Постер без объяснения. ____',
            '2. Карточка «если потерялась — остановись». ____',
            '3. Красивый рисунок без текста. ____',
            '4. Мини-гайд «стоп, уйти, рассказать». ____',
            '5. Список настоящих телефонов семьи. ____',
            '6. Схема «как измерить линейкой». ____',
            '7. Обещание «это решит любую проблему». ____',
            '8. Карточка «спроси родителя перед поиском». ____'
          ] },
          { type: 'text', text: 'Задание 5 — Карточки пользы.' },
          { type: 'list', items: [
            '4 идеи × 3 benefit cards = ______',
            '4 − 2 идеи = ______ идеи останется',
            '2 идеи × 5 шагов = ______ шагов',
            '12 benefit cards + 10 steps = ______'
          ] },
          { type: 'text', text: 'Задание 6 — Таблица аудитории. Семья — 6. Младшие дети — 8. Родитель — 5. Нимни — 7.' },
          { type: 'list', items: [
            '1. Больше всего: ____________________',
            '2. 8 − 5 = ______',
            '3. Семья + Нимни = 6 + 7 = ______',
            '4. 24 ÷ 6 = ______'
          ] }
        ] },
      { title: 'Карточка полезного контента / Useful Content Card',
        blocks: [
          { type: 'text', text: 'Задание 7 — Мини-график целей.' },
          { type: 'list', items: [
            'объяснить: □ □ □ □ □',
            'предупредить: □ □ □',
            'помочь выбрать: □ □ □ □',
            'напомнить: □ □'
          ] },
          { type: 'list', items: [
            '1. Чаще всего: ____________________',
            '2. Объяснить больше, чем напомнить, на: ______',
            '3. Всего целей: ______'
          ] },
          { type: 'text', text: 'Задание 8 — Правописание. Напиши и вставь буквы:' },
          { type: 'list', items: ['цель   польза   пример   шаг   черновик', 'ц_ль   п_льза   прим_р   ш_г   черн_вик'] },
          { type: 'text', text: 'Задание 9 — Useful Content Card.' },
          { type: 'list', items: [
            'Моя тема: ____________________',
            'Моя цель: ____________________',
            'Кому поможет: ____________________',
            'Что объяснит: ____________________',
            'Почему полезно: ____________________',
            'Маленький значок темы: ____________________'
          ] },
          { type: 'text', text: 'Задание 10 — Объясни родителю. Поставь галочку:' },
          { type: 'list', items: [
            '□ Моя цель — ______.',
            '□ Моя аудитория — ______.',
            '□ Мой контент поможет понять ______.'
          ] },
          { type: 'text', text: 'Parent Check: □ Прочитала слова  □ Прочитала 4 фразы  □ Подобрала аудиторию  □ Решила математику  □ Сделала Useful Content Card  □ Объяснила цель родителю.' },
          { type: 'text', text: 'Notebook Mode — если нет принтера, сделай эти задания в тетради.' }
        ] }
    ]
  },
  parentGuide: {
    goal: 'Анита понимает, что у полезного контента есть цель, аудитория и польза.',
    mathGoal: 'Умножение 4 × 3, 2 × 5, деление 24 ÷ 6, таблицы и мини-графики.',
    russianGoal: 'Прочитать слова цель, аудитория, польза, объяснить, пример, шаг, карточка, понятно, безопасно, черновик.',
    readingWritingGoal: 'Прочитать 4 фразы, заполнить Useful Content Card.',
    practicalGoal: 'Выбрать безопасную аудиторию и объяснить пользу своего контента.',
    parentTheoryCard: {
      title: 'Как объяснить цель и аудиторию',
      purpose: 'Помочь родителю показать, что создание полезного начинается не с красивой картинки, а с вопроса «зачем и для кого?».',
      keyMessage: 'Полезный контент помогает конкретному человеку понять или сделать что-то безопасное.',
      parentScript: [
        '«Цель — зачем ты это создаёшь.»',
        '«Аудитория — кому это поможет.»',
        '«Польза — что человек поймёт или сможет сделать.»',
        '«Безопасная аудитория в этом курсе — семья, родитель, Нимни или выдуманный ребёнок, не незнакомцы онлайн.»'
      ],
      practiceSteps: [
        'Выберите одну тему.',
        'Спросите: кому поможет?',
        'Спросите: что объяснит?',
        'Спросите: почему полезно?',
        'Заполните карточку.'
      ],
      doNotSay: [
        'Не говорить: «Сделай красиво и всё.»',
        'Не требовать идеальный дизайн.',
        'Не предлагать публиковать онлайн.',
        'Не просить реальные имена или личные данные.'
      ],
      paperOnlyNotes: [
        'Карточка делается на бумаге или в тетради.',
        'Аудитория может быть выдуманной или семейной.'
      ]
    },
    whatThisLessonTeaches: 'Анита учится создавать с целью, а не просто украшать.',
    keyMessage: 'Автор думает: кому поможет мой результат?',
    howToExplain: 'Скажите: «Если карточка красивая, это хорошо. Но если она ещё помогает понять правило — это уже полезный контент.»',
    exampleDialogue:
      'Parent: Какая твоя тема?\nChild: Как не вводить пароль.\nParent: Кому поможет?\nChild: Ребёнку.\nParent: Что объяснит?\nChild: Что пароль нельзя писать.\nParent: Почему полезно?\nChild: Это безопасно.',
    readingSupport: 'Слова «аудитория», «черновик», «объяснить» читать по частям.',
    russianSpeechGoal: 'Анита говорит цель, аудиторию и пользу.',
    mathAnswerKey:
      'math-benefit-cards: 1) 12. 2) 2. 3) 10. 4) 22.\nmath-audience-table: 1) Младшие дети. 2) 3. 3) 13. 4) 4.\nmini-purpose-graph: 1) Объяснить. 2) 3. 3) 14.',
    spellingAnswerKey: 'цель\nпольза\nпример\nшаг\nчерновик',
    answerKey: [
      { taskId: 'reading-words', answer: 'Попытка русского чтения.' },
      { taskId: 'reading-sentences', answer: 'Попытка русского чтения.' },
      { taskId: 'purpose-audience-match', answer: '1-D, 2-A, 3-E, 4-B, 5-C.' },
      { taskId: 'useful-not-useful-sort', answer: 'useful: 2,4,6,8,10,12; pretty only: 1,3,9; parent check: 5,7,11.' },
      { taskId: 'math-benefit-cards', answer: '12; 2; 10; 22.' },
      { taskId: 'math-audience-table', answer: 'младшие дети; 3; 13; 4.' },
      { taskId: 'mini-purpose-graph', answer: 'объяснить; 3; 14.' },
      { taskId: 'spelling-purpose', answer: 'цель, польза, пример, шаг, черновик.' },
      { taskId: 'creative-useful-content-card', answer: 'card includes topic, purpose, audience, benefit.' },
      { taskId: 'speech-purpose-explain', answer: 'explanation attempted.' }
    ],
    check: [
      'Анита прочитала слова и фразы.',
      'Анита поняла цель и аудиторию.',
      'Анита решила math tasks.',
      'Анита сделала Useful Content Card.',
      'Анита объяснила пользу.'
    ],
    spellingCheck: 'Проверить цель, польза, пример, шаг, черновик.',
    readingCheck: 'Главное — попытка и понимание.',
    practicalCheck: 'Аудитория безопасная, без реальных незнакомцев и онлайн-публикации.',
    drawingCriteria: 'Карточка содержит тему, цель, аудиторию, пользу и значок.',
    commonMistakes: [
      '«Аудитория — это любые люди в интернете.» Правильно: «В курсе аудитория безопасная: семья, родитель, Нимни, выдуманный ребёнок.»',
      '«Польза — это просто красиво.» Правильно: «Польза помогает понять или сделать.»',
      '«Черновик должен быть идеальным.» Правильно: «Черновик помогает начать.»'
    ],
    discussionPrompts: [
      'Кому поможет твоя карточка?',
      'Что человек сможет понять?',
      'Почему это безопасно?'
    ],
    ifEasy: 'Попросить Аниту придумать 2 разные аудитории для одной темы.',
    ifDifficult: 'Дать готовую тему: «не вводи пароль» и заполнить только цель + аудиторию.',
    rewardGuidance: 'Базовая награда — 3 нима. Бонус за ясную цель или аккуратную карточку.',
    tokenReward: 'Нимы — это призовые токены курса, а не оплата.',
    parentOnlyNotes: 'Не использовать реальные имена, аккаунты, фото, школу или личные данные.',
    safetyNotes: 'Создание в курсе — paper-only and parent-reviewed. Никаких публикаций, аккаунтов или контактов с незнакомцами.'
  },
  reward: { unit: 'nim', unitName: 'ним', base: 3, max: 5, label: 'Награда за миссию', display: '3 нима',
    bonuses: [
      { id: 'clear-purpose', label: 'Бонус за ясную цель', amount: 1 },
      { id: 'neat-card', label: 'Бонус за аккуратную Useful Content Card', amount: 1 }
    ] },
  completionRequirements: {
    requiredTaskIds: ['reading-words', 'reading-sentences', 'purpose-audience-match', 'useful-not-useful-sort', 'math-benefit-cards', 'math-audience-table', 'mini-purpose-graph', 'spelling-purpose', 'creative-useful-content-card', 'speech-purpose-explain'],
    allowNotebookCompletion: true
  },
  nextLessonId: 'anita-week-9-day-3'
};

export default day2;
